module.exports = __webpack_public_path__ + "static/plan_wondercoco-fa7d30b36f660ad7b6737058a4252ef7.svg";